const getValueType = (fieldType: string): string => {
  switch (fieldType) {
    case 'text':
      return 'string'

    case 'date':
      return 'date'

    case 'long_text':
      return 'string'

    case 'checkbox':
      return 'boolean'

    case 'cents':
      return 'cents'

    case 'money':
      return 'cents'

    case 'single_choice':
      return 'string'

    case 'multiple_choice':
      return 'any'

    case 'rating':
      return 'any'

    default:
      throw new Error(`The FieldType ${fieldType} doesn't exist`)
  }
}

export default getValueType
